var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"switch",class:{
    'switch-active':_vm.value,
    'switch-inactive':!_vm.value
  },style:({minWidth:(_vm.width + "px")}),on:{"click":function($event){$event.preventDefault();return _vm.change.apply(null, arguments)}}},[_c('i',{staticClass:"text"},[_vm._v(_vm._s(_vm.hasText ? (_vm.value ? _vm.activeText : _vm.inActiveText):''))])])}
var staticRenderFns = []

export { render, staticRenderFns }